import { BackTop } from "@pankod/refine-antd";
import React from 'react';

export const OffLayoutArea: React.FC = () => {
  return null; //<BackTop />;
};
